<template>
  <div v-if="permission.access">
    <validation-observer ref="loginValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
        enctype="multipart/form-data"
      >
        <b-card>
          <b-card-title> Banner Section </b-card-title>
          <div class="row">
            <!-- Basic information -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3">
                  <!-- email -->
                  <b-form-group label="Super Title" label-for="super_title">
                    <b-form-input
                      id="super_title"
                      v-model="form.super_title"
                      name="super_title"
                      placeholder="Enter Your Super Title"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <!-- email -->
                  <b-form-group label="Course Name Bangla" label-for="name_bn">
                    <validation-provider
                      #default="{ errors }"
                      name="name_bn"
                      rules="required"
                    >
                      <b-form-input
                        id="name_bn"
                        v-model="form.name_bn"
                        :state="errors.length > 0 ? false : null"
                        name="name_bn"
                        placeholder="Enter Your Course Name Bangla"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <!-- email -->
                  <b-form-group label="Course Name English" label-for="name_en">
                    <validation-provider
                      #default="{ errors }"
                      name="name_en"
                      rules="required"
                    >
                      <b-form-input
                        id="name_en"
                        v-model="form.name_en"
                        :state="errors.length > 0 ? false : null"
                        name="name_en"
                        placeholder="Enter Your Course Name English"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Enter Course Slug" label-for="slug">
                     <validation-provider
                      #default="{ errors }"
                      name="slug"
                      rules="required"
                    >
                    <b-form-input
                      id="slug"
                      v-model="form.slug"
                      name="slug"
                       :state="errors.length > 0 ? false : null"
                      placeholder="Enter Course Slug"
                    />
                     <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Button Name 1" label-for="btn_1">
                    <b-form-input
                      id="btn_1"
                      v-model="form.btn_1"
                      name="btn_1"
                      placeholder="Enter Your Button Name"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Button Link 1" label-for="btn_link_1">
                    <b-form-input
                      id="btn_link_1"
                      v-model="form.btn_link_1"
                      name="btn_link_1"
                      placeholder="Enter Your Button Link"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Button Name 2" label-for="btn_1">
                    <b-form-input
                      id="btn_2"
                      v-model="form.btn_2"
                      name="btn_2"
                      placeholder="Enter Your Button Name"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Button Link 2" label-for="btn_link_2">
                    <b-form-input
                      id="btn_link_2"
                      v-model="form.btn_link_2"
                      name="btn_link_2"
                      placeholder="Enter Your Button Link"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <!-- email -->
                      <b-form-group label="Duration" label-for="duration">
                        <b-form-input
                          id="duration"
                          v-model="form.duration"
                          name="duration"
                          placeholder="Enter Your Duration"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <!-- email -->
                      <b-form-group label="Total Class" label-for="total_class">
                        <b-form-input
                          id="total_class"
                          v-model="form.total_class"
                          name="total_class"
                          placeholder="Enter Your Total Class"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <!-- email -->
                      <b-form-group
                        label="Total Project"
                        label-for="total_project"
                      >
                        <b-form-input
                          id="total_project"
                          v-model="form.total_project"
                          name="total_project"
                          placeholder="Enter Your Total Project"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <!-- email -->
                      <b-form-group
                        label="Total Student"
                        label-for="total_student"
                      >
                        <b-form-input
                          id="total_student"
                          v-model="form.total_student"
                          name="total_student"
                          placeholder="Enter Your Total Student"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <!-- email -->
                      <b-form-group
                        label="Total Review"
                        label-for="total_review"
                      >
                        <b-form-input
                          id="total_review"
                          v-model="form.total_review"
                          name="total_review"
                          placeholder="Enter Your Total Review"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                        label="Offline Course Fee"
                        label-for="offline_fee"
                      >
                        <b-form-input
                          id="offline_fee"
                          v-model="form.offline_fee"
                          name="offline_fee"
                          placeholder="Enter Your Offline Course Fee"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Offline Course Fee Discount"
                        label-for="offline_discount_fee"
                      >
                        <b-form-input
                          id="offline_discount_fee"
                          v-model="form.offline_discount_fee"
                          name="offline_discount_fee"
                          placeholder="Enter Your Offline Course Fee Discount"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Online Course Fee"
                        label-for="online_fee"
                      >
                        <b-form-input
                          id="online_fee"
                          v-model="form.online_fee"
                          name="online_fee"
                          placeholder="Enter Your Online Course Fee"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Online Course Fee Discount"
                        label-for="online_discount_fee"
                      >
                        <b-form-input
                          id="online_discount_fee"
                          v-model="form.online_discount_fee"
                          name="online_discount_fee"
                          placeholder="Enter Your Online Course Fee Discount"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                        label="Theory Class Count"
                        label-for="theory_class_count"
                      >
                        <b-form-input
                          id="theory_class_count"
                          v-model="form.theory_class_count"
                          name="theory_class_count"
                          placeholder="Enter Theory Class Count"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Lab Class Count"
                        label-for="lab_class_count"
                      >
                        <b-form-input
                          id="lab_class_count"
                          v-model="form.lab_class_count"
                          name="lab_class_count"
                          placeholder="Enter Your Lab Count"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Online Class Count"
                        label-for="online_class_count"
                      >
                        <b-form-input
                          id="online_class_count"
                          v-model="form.online_class_count"
                          name="online_class_count"
                          placeholder="Enter Class Count"
                        />
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        label="Prerecorded Class Count"
                        label-for="prerecorded_class_count"
                      >
                        <b-form-input
                          id="prerecorded_class_count"
                          v-model="form.prerecorded_class_count"
                          name="prerecorded_class_count"
                          placeholder="Enter Prerecorded Class Count"
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Course overview video -->
            <div class="col-md-12">
              <div class="border rounded p-2 mb-2">
                <h4 class="mb-1">Video Setting</h4>

                <b-media
                  no-body
                  vertical-align="center"
                  class="flex-column flex-md-row"
                >
                  <b-media-aside>
                    <b-img
                      :src="video_thumbnail"
                      height="174"
                      width="310"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <b-form-group
                      label="Video Thumbnail"
                      label-for="video_thumbnail"
                    >
                      <b-form-file
                        id="video_thumbnail"
                        accept=".jpg, .png, .gif"
                        @change="loadImage($event)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                      />
                    </b-form-group>
                    <b-form-group label="Video ID" label-for="video_url">
                      <validation-provider
                        #default="{ errors }"
                        name="video_url"
                      >
                        <b-form-input
                          id="video_url"
                          v-model="form.video_url"
                          :state="errors.length > 0 ? false : null"
                          name="video_url"
                          placeholder="Enter Your Video ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-media-body>
                </b-media>
              </div>
            </div>

            <!-- Demo Video Section -->
            <!-- 
            <div class="col-md-12">
              <div class="border rounded p-2 mb-2">
                <h4 class="mb-1">Demo Video Setting</h4>

                <b-media
                  no-body
                  vertical-align="center"
                  class="flex-column flex-md-row"
                >
                  <b-media-aside>
                    <b-img
                      :src="demo_video_thumbnail"
                      height="174"
                      width="310"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <b-form-group
                      label="Demo Video Thumbnail"
                      label-for="demo_video_thumbnail"
                    >
                      <b-form-file
                        id="demo_video_thumbnail"
                        accept=".jpg, .png, .gif"
                        @change="loadDemoVideoImage($event)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                      />
                    </b-form-group>
                    <b-form-group label="Video ID" label-for="demo_video_url">
                      <validation-provider
                        #default="{ errors }"
                        name="demo_video_url"
                      >
                        <b-form-input
                          id="demo_video_url"
                          v-model="form.demo_video_id"
                          :state="errors.length > 0 ? false : null"
                          name="demo_video_id"
                          placeholder="Enter Your Video ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-media-body>
                </b-media>
              </div>
            </div> -->
          </div>
          <!-- Course Category -->
          <b-form-group label="Select Department" label-for="department_id">
            <validation-provider
              #default="{ errors }"
              name="department_id"
              rules="required"
            >
              <v-select
                id="department_id"
                v-model="form.department_id"
                multiple
                placeholder="Select Department"
                :options="departments"
                label="name_en"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

            <b-form-group
                      label="Course Brochure"
                      label-for="course_brochure"
                    >
                      <b-form-file
                        id="course_brochure"
                        accept=".pdf"
                        @change="loadCourseBrochure($event)"
                        placeholder="Choose a pdf file "
                      />
                    </b-form-group>
          <!-- Course success story -->
          <!-- <b-form-group
            label="Select Success Story"
            label-for="success_story_id"
          >
            <validation-provider #default="{ errors }" name="success_story_id">
              <v-select
                id="success_story_id"
                v-model="form.success_story_id"
                placeholder="Select Success Story"
                multiple
                :options="options.success_stories"
                label="title"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group> -->
        </b-card>

        <!-- Course overview section -->
        <b-card>
          <b-card-title> Course Over View </b-card-title>
          <b-form-group label="Title" label-for="course_over_view_title">
            <b-form-input
              id="course_over_view_title"
              v-model="form.course_over_view_title"
              name="course_over_view_title"
              placeholder="Enter Your Course Over View Title"
            />
          </b-form-group>
          <div class="d-block" style="height: 410px">
            <b-form-group
              label="Course Over View Description"
              label-for="course_over_view_description"
            >
              <!-- :options="snowOption" -->
              <quill-editor
                id="course_over_view_description"
                style="height: 320px"
                class="mb-4"
                v-model="form.course_over_view_description"
                name="course_over_view_description"
                placeholder="Enter Your Course Over View Title"
              />
            </b-form-group>
          </div>
        </b-card>

        <!-- Course highlighted section -->
        <b-card>
          <b-card-title>Course Key Highlighted </b-card-title>
          <b-form-group label="Title" label-for="course_key_hightlight_title">
            <b-form-input
              id="course_key_hightlight_title"
              v-model="form.course_key_hightlight_title"
              name="course_key_hightlight_title"
              placeholder="Enter  Course Key Highlight Title"
            />
          </b-form-group>
          <div
            class="row mb-1"
            v-for="(feature, index) in form.short_description"
            :key="index"
            v-if="form.short_description.length"
          >
            <div class="col-md-10 col-9">
              <b-form-input
                v-model="form.short_description[index]"
                name="feature"
                placeholder="Enter Course Key Highlight"
              />
            </div>
            <div class="col-md-2 col-3">
              <b-button
                v-if="index == form.short_description.length - 1"
                variant="primary"
                class="w-100"
                type="button"
                @click="addFeature()"
              >
                Add More
              </b-button>
              <b-button
                v-if="index != form.short_description.length - 1"
                variant="danger"
                class="w-100"
                type="button"
                @click="removeFeature(index)"
              >
                Delete
              </b-button>
            </div>
          </div>
        </b-card>

        <!-- Course Software Section -->
        <b-card>
          <b-card-title> Course Software Section </b-card-title>
          <b-form-group label="Title" label-for="course_software_title">
            <validation-provider
              #default="{ errors }"
              name="course_software_title"
            >
              <b-form-input
                id="course_software_title"
                v-model="form.course_software_title"
                :state="errors.length > 0 ? false : null"
                name="course_software_title"
                placeholder="Enter Your Course Software Section Title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Select Software" label-for="softwares">
            <validation-provider #default="{ errors }" name="softwares">
              <v-select
                id="softwares"
                v-model="form.softwares"
                placeholder="Select Software"
                multiple
                :options="options.softwares"
                label="name"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card>

        <!-- Course For Whom Section -->
        <b-card>
          <b-card-title> Course For Whom Section </b-card-title>
          <b-form-group label="Title" label-for="course_whom_title">
            <validation-provider
              #default="{ errors }"
              name="course_whom_title"
            >
              <b-form-input
                id="course_whom_title"
                v-model="form.course_whom_title"
                :state="errors.length > 0 ? false : null"
                name="course_whom_title"
                placeholder="Enter Course For Whom Title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Select" label-for="course_whoms">
            <validation-provider #default="{ errors }" name="course_whoms">
              <v-select
                id="course_whoms"
                v-model="form.course_whoms"
                placeholder="Select Whom"
                multiple
                :options="options.work_for_whom"
                label="name"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card>

        <!-- Course PreRequisite Section -->
        <b-card>
          <b-card-title> Course PreRequisite Section </b-card-title>
          <b-form-group label="Title" label-for="course_prequisite_title">
            <validation-provider
              #default="{ errors }"
              name="course_prequisite_title"
            >
              <b-form-input
                id="course_prequisite_title"
                v-model="form.course_prequisite_title"
                :state="errors.length > 0 ? false : null"
                name="course_prequisite_title"
                placeholder="Enter Course Prequisite title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Select Prerequisite"
            label-for="course_prerequisites"
          >
            <validation-provider
              #default="{ errors }"
              name="course_prerequisites"
            >
              <v-select
                id="course_prerequisites"
                v-model="form.course_prerequisites"
                placeholder="Select Prerequiste"
                multiple
                :options="options.course_prerequisites"
                label="name"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card>
        <!-- Course Delivery Mood Section -->
        <b-card>
          <b-card-title> Course Delivery Mood Section </b-card-title>
          <b-form-group label="Title" label-for="delivery_mood_title">
            <validation-provider
              #default="{ errors }"
              name="delivery_mood_title"
            >
              <b-form-input
                id="delivery_mood_title"
                v-model="form.delivery_mood_title"
                :state="errors.length > 0 ? false : null"
                name="delivery_mood_title"
                placeholder="Enter Course Delivery Mood title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Select Delivery Mood" label-for="delivery_moods">
            <validation-provider #default="{ errors }" name="delivery_moods">
              <v-select
                id="delivery_moods"
                v-model="form.delivery_moods"
                placeholder="Select Delivery Mood"
                multiple
                :options="options.delivery_moods"
                label="name"
                :reduce="(option) => option.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card>

        <!-- Course Facilities Section -->
        <b-card>
          <b-card-title> Course Facilities Section </b-card-title>
          <b-form-group label="Title" label-for="course_facilities_title">
            <b-form-input
              id="course_facilities_title"
              v-model="form.course_facilities_title"
              name="course_facilities_title"
              placeholder="Enter Your Course Facilities Section Title"
            />
          </b-form-group>
          <b-form-group label="Select Course Facilities" label-for="facilities">
            <v-select
              id="facilities"
              v-model="form.facilities"
              placeholder="Select Course Facilities"
              multiple
              :options="options.facilities"
              label="name"
              :reduce="(option) => option.id"
            />
          </b-form-group>
        </b-card>

        <!-- Course Exclusive Services section -->
        <b-card>
          <b-card-title> Course Services Section </b-card-title>
          <b-form-group
            label="Title"
            label-for="course_facilities_service_title"
          >
            <b-form-input
              id="course_facilities_service_title"
              v-model="form.course_facilities_service_title"
              name="course_facilities_service_title"
              placeholder="Enter Course Services Section Title"
            />
          </b-form-group>
          <b-form-group
            label="Select Course Services"
            label-for="course_services"
          >
            <v-select
              id="course_services"
              v-model="form.course_services"
              placeholder="Select Course Exclusive Services"
              multiple
              :options="options.course_services"
              label="name"
              :reduce="(option) => option.id"
            />
          </b-form-group>
        </b-card>

        <!-- Course Student work section title -->
        <b-card>
          <b-card-title> Student Work Section Title</b-card-title>
          <b-form-group label="Title" label-for="student_work_title">
            <b-form-input
              id="student_work_title"
              v-model="form.student_work_title"
              name="student_work_title"
              placeholder="Enter Your Student Work Section Title"
            />
          </b-form-group>
        </b-card>

        <!-- Course FAQ Section -->
        <b-card>
          <b-card-title> Course FAQ Section </b-card-title>
          <b-form-group label="Title" label-for="course_faq_title">
            <b-form-input
              id="course_faq_title"
              v-model="form.course_faq_title"
              name="course_faq_title"
              placeholder="Enter Your Course FAQ Section Title"
            />
          </b-form-group>
          <b-form-group label="Select Course FAQ" label-for="faq">
            <v-select
              id="faq"
              v-model="form.faq_id"
              placeholder="Select Course FAQ"
              multiple
              :options="faqs"
              label="question"
              :reduce="(option) => option.id"
            />
          </b-form-group>
        </b-card>

        <!-- Course Meta Section -->
        <div class="row">
          <div class="col-md-12">
            <b-card>
              <b-card-title> Meta Section </b-card-title>
              <b-form-group label="Meta Title" label-for="meta_title">
                <validation-provider #default="{ errors }" name="meta_title">
                  <b-form-input
                    id="meta_title"
                    v-model="form.meta_title"
                    :state="errors.length > 0 ? false : null"
                    name="meta_title"
                    placeholder="Enter Your Meta Title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Meta Description"
                label-for="meta_description"
              >
                <validation-provider
                  #default="{ errors }"
                  name="meta_description"
                >
                  <b-form-textarea
                    id="meta_description"
                    v-model="form.meta_description"
                    :state="errors.length > 0 ? false : null"
                    name="meta_description"
                    placeholder="Enter Your Meta Description"
                    rows="2"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-card>
          </div>
        </div>

        <!-- Course Status Section -->
        <b-card>
          <b-card-title> Status Section </b-card-title>
          <b-form-checkbox
            name="is_diploma"
            class="mr-5"
            v-model="form.is_diploma"
            switch
            inline
          >
            Is Diploma
          </b-form-checkbox>
          <b-form-checkbox
            name="is_admission"
            class="mr-5"
            v-model="form.is_admission"
            switch
            inline
          >
            Is Admission
          </b-form-checkbox>
          <b-form-checkbox
            class="mr-5"
            name="is_seminar"
            v-model="form.is_seminar"
            switch
            inline
          >
            Is Seminar
          </b-form-checkbox>
          <b-form-checkbox name="status" v-model="form.status" switch inline>
            Status
          </b-form-checkbox>
        </b-card>
        <div class="d-flex justify-content-end mb-5">
          <b-button type="submit" variant="primary" @click="validationForm">
            Save
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BButton,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardTitle,
  BImg,
  BForm,
  BFormTextarea,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
export default {
  components: {
    BCard,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
    quillEditor,
    vSelect,
  },
  data() {
    return {
      required,
      email,
      snowOption: {
        minHeight: 200,
      },
      form: {
        super_title: "",
        department: "",
        name_en: "",
        name_bn: "",
        slug: "",
        short_description: [""],
        btn_1: "",
        btn_link_1: "",
        btn_2: "",
        btn_link_2: "",
        duration: "",
        total_class: "",
        theory_class_count: "",
        lab_class_count: "",
        online_class_count: "",
        prerecorded_class_count: "",
        total_project: "",
        total_student: "",
        offline_fee: 0,
        offline_discount_fee: 0,
        online_fee: 0,
        online_discount_fee: 0,
        total_review: "",
        video_url: "",
        course_over_view_title: "",
        course_over_view_description: "",
        course_key_hightlight_title: "",
        video_thumbnail: null,
        course_brochure: null,
        success_story_id: [],
        course_software_title: "",
        delivery_mood_title: "",
        course_prequisite_title: "",
        course_facilities_service_title: "",
        course_whom_title: "",
        softwares: [],
        delivery_moods: [],
        course_services: [],
        course_whoms: [],
        course_prerequisites: [],
        course_facilities_title: "",
        facilities: [],
        student_work_title: "",
        meta_title: "",
        meta_description: "",
        demo_video_id: "",
        demo_video_thumbnail: "",
        status: true,
        is_admission: true,
        is_diploma: false,
        is_seminar: true,
        department_id: [],
        faq_id: [],
        course_faq_title: "",
      },
      faqs: [],
      video_thumbnail: this.$store.state.base_url + "images/course/default.png",
      demo_video_thumbnail:
        this.$store.state.base_url + "images/course/default.png",
      permission: {
        access: false,
      },
    };
  },
  mounted() {
    this.Permission();
    this.$store.dispatch("getOption");
    this.$store.dispatch("getDepartment");
    this.getFaqs();
  },
  methods: {
    async getFaqs() {
      const faqs = await this.callApi("get", "/app/faq/active/get");
      if (faqs?.status == 200) {
        this.faqs = faqs.data.faqs;
      }
    },
    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "course.create") {
          this.permission.access = true;
        }
      });
    },

    addFeature() {
      this.form.short_description.push("");
    },
    removeFeature(index) {
      this.form.short_description.splice(index, 1);
    },

    loadImage(e) {
      this.form.video_thumbnail = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.video_thumbnail = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    loadDemoVideoImage(e) {
      this.form.demo_video_thumbnail = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.demo_video_thumbnail = e.target.result;
      };
      reader.readAsDataURL(file);
    },
      loadCourseBrochure(e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.form.course_brochure = file;
      };
      reader.readAsDataURL(file);
    },

    add() {
      const fd = new FormData();
      if (this.form.video_thumbnail) {
        fd.append("video_thumbnail", this.form.video_thumbnail);
      }
      if (this.form.demo_video_thumbnail) {
        fd.append("demo_video_thumbnail", this.form.demo_video_thumbnail);
      }
      if (this.form.course_brochure) {
        fd.append("course_brochure", this.form.course_brochure);
      }

      let option_data = [];
      this.form.softwares.forEach((data) => {
        option_data.push(data);
      });
      this.form.course_whoms.forEach((data) => {
        option_data.push(data);
      });
      this.form.course_prerequisites.forEach((data) => {
        option_data.push(data);
      });
      this.form.delivery_moods.forEach((data) => {
        option_data.push(data);
      });

      this.form.facilities.forEach((data) => {
        option_data.push(data);
      });
      this.form.course_services.forEach((data) => {
        option_data.push(data);
      });

      for (let i = 0; i < option_data.length; i++) {
        let option = option_data[i];
        fd.append("options[" + i + "]", option);
      }

      for (let i = 0; i < this.form.department_id.length; i++) {
        let department = this.form.department_id[i];
        fd.append("department_id[" + i + "]", department);
      }

      for (let i = 0; i < this.form.success_story_id.length; i++) {
        let success_story_id = this.form.success_story_id[i];
        fd.append("success_story_id[" + i + "]", success_story_id);
      }

      for (let i = 0; i < this.form.short_description.length; i++) {
        let short_description = this.form.short_description[i];
        fd.append("short_description[" + i + "]", short_description);
      }

      for (let i = 0; i < this.form.faq_id.length; i++) {
        let faq = this.form.faq_id[i];
        fd.append("faq_id[" + i + "]", faq);
      }

      fd.append("super_title", this.form.super_title);
      fd.append("department", this.form.department);
      fd.append("name_en", this.form.name_en);
      fd.append("name_bn", this.form.name_bn);
      fd.append("slug", this.form.slug);
      fd.append("btn_1", this.form.btn_1);
      fd.append("btn_link_1", this.form.btn_link_1);
      fd.append("btn_2", this.form.btn_2);
      fd.append("btn_link_2", this.form.btn_link_2);
      fd.append("duration", this.form.duration);
      fd.append("total_class", this.form.total_class);
      fd.append("total_project", this.form.total_project);
      fd.append("total_student", this.form.total_student);
      fd.append("total_review", this.form.total_review);
      fd.append("video_url", this.form.video_url);
      fd.append("course_over_view_title", this.form.course_over_view_title);
      fd.append("course_key_hightlight_title", this.form.course_key_hightlight_title);
      fd.append(
        "course_over_view_description",
        this.form.course_over_view_description
      );
      fd.append("demo_video_id", this.form.demo_video_id);
      fd.append("course_software_title", this.form.course_software_title);
      fd.append("softwares", this.form.softwares);
      fd.append("course_whom_title", this.form.course_whom_title);
      fd.append("course_prequisite_title", this.form.course_prequisite_title);
      fd.append("course_whoms", this.form.course_for_whom);
      fd.append("course_prerequisites", this.form.course_prerequisites);
      fd.append("course_services", this.form.course_services);
      fd.append(
        "course_facilities_service_title",
        this.form.course_facilities_service_title
      );
      fd.append("course_facilities_title", this.form.course_facilities_title);
      fd.append("delivery_mood_title", this.form.delivery_mood_title);
      fd.append("facilities", this.form.facilities);
      fd.append("delivery_moods", this.form.delivery_moods);
      fd.append("student_work_title", this.form.student_work_title);
      fd.append("meta_title", this.form.meta_title);
      fd.append("meta_description", this.form.meta_description);
      fd.append("status", this.form.status);
      fd.append("is_admission", this.form.is_admission);
      fd.append("is_diploma", this.form.is_diploma);
      fd.append("is_seminar", this.form.is_seminar);
      fd.append("offline_fee", this.form.offline_fee);
      fd.append("offline_discount_fee", this.form.offline_discount_fee);
      fd.append("online_fee", this.form.online_fee);
      fd.append("online_discount_fee", this.form.online_discount_fee);
      fd.append("course_faq_title", this.form.course_faq_title);
      fd.append("theory_class_count", this.form.theory_class_count);
      fd.append("online_class_count", this.form.online_class_count);
      fd.append("prerecorded_class_count", this.form.prerecorded_class_count);
      fd.append("lab_class_count", this.form.lab_class_count);

      axios
        .post("/app/course/store", fd)
        .then((res) => {
          this.s(res.data.message);
          this.$router.push("/course");
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.name_en) {
              this.e(e.response.data.errors.name_en[0]);
            }
            if (e.response.data.errors.video_thumbnail) {
              this.e(e.response.data.errors.video_thumbnail[0]);
            }
          }
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.add();
        }
      });
    },
  },
  computed: {
    options() {
      return this.$store.getters.getOption;
    },
    departments() {
      return this.$store.getters.getDepartment;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.image_div {
  position: relative;
}
.image_delete {
  width: 25px;
  height: 25px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 5px;
  right: 30px;
  background: rgba(0, 0, 0, 0.548);
  cursor: pointer;
  border-radius: 50%;
}
</style>
